module.exports = __webpack_public_path__ + "img/10.d65d0f9b.jpg";